/**
 * convert an array to a comma separated list, i.e. ['a', 'b', 'c'] -> 'a, b & c'
 *
 * @param {string[]} arr
 * @param {string} separator
 * @param {string} finalSeparator
 * @returns {string}
 */
const arrayToList = ( arr, separator = ', ', finalSeparator = ' & ' ) =>
{
	return arr
		.map( ( item, key ) =>
		{
			const joinChar = key === arr.length - 2 ? finalSeparator : separator;

			return item + (key === arr.length - 1 ? '' : joinChar);
		} )
		.join( '' );
};


/**
 *
 */
export {arrayToList};